import type { ReactNode } from "react";
import { Link } from "react-router";
import { Icon } from "./Icon";

/** A page's head (`.ph`): an optional way back, the title, one line under it, and the page's actions at the right. */
export function PageHeader({ title, sub, actions, back }: {
  title: ReactNode;
  sub?: ReactNode;
  actions?: ReactNode;
  back?: { to: string; label: string };
}) {
  return (
    <>
      {back ? (
        <Link className="back" to={back.to}>
          <Icon name="left" />
          {back.label}
        </Link>
      ) : null}
      <div className="ph">
        <div>
          <h1>{title}</h1>
          {sub ? <p>{sub}</p> : null}
        </div>
        {actions ? <div className="row g8 wrap">{actions}</div> : null}
      </div>
    </>
  );
}
